@import '../../../../../../constants/spacing.module.less';
@import '../new-lineup-plan-grid-shared-styles.module.less';

.compare-features-section {
  background: var(--light--background-color--1);
  border: solid 1px var(--default--border-color--12);
  border-radius: 8px;
  margin-bottom: @space-24;
  padding: @space-16;
}

.compare-features-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}

.features-grid-container {
  display: grid;
  margin-top: @space-16;
}

.plan-names-row {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: var(--light--background-color--1);
}

.plan-name-cell {
  text-align: center;
  padding: @space-8 @space-16;

  &.is-current-plan-column {
    background-color: @current-column-background-color;
  }
}
